import "./StatusBadge.css";

function StatusBadge({ status }) {
  const getClassName = () => {
    switch (status) {
      case "Pending":
        return "pending";

      case "Accepted":
        return "accepted";

      case "Preparing":
        return "preparing";

      case "Ready":
        return "ready";

      case "Assigned":
        return "assigned";

      case "Picked Up":
        return "pickup";

      case "Out For Delivery":
        return "delivery";

      case "Delivered":
        return "delivered";

      case "Rejected":
        return "rejected";

      default:
        return "default";
    }
  };

  return (
    <span className={`status-badge ${getClassName()}`}>
      {status}
    </span>
  );
}

export default StatusBadge;